<div class="gather-wrapper view-container" [ngClass]='brand ? "brand-" + brand : "brand-aq"'>
  <div class="header">
    <app-gather-header [headerText]="showHeaderText ? $safeNavigationMigration(posting?.jobTitle) : null"></app-gather-header>
  </div>
  <div class="content-wrap">
    <app-gather-loader></app-gather-loader>
    <div [ngClass]="{'hidden': loading}">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div [ngClass]="{'hidden': loading}" class="footer">
    <app-gather-footer [countryId]="$safeNavigationMigration(posting?.countryId)"></app-gather-footer>
  </div>
</div>
